import { useState, useEffect } from 'react';

const links = [
  { id: 'works', label: 'WORKS', jp: '作品' },
  { id: 'profile', label: 'PROFILE', jp: '書家' },
  { id: 'activities', label: 'ACTIVITIES', jp: '活動' },
  { id: 'order', label: 'ORDER', jp: '依頼' },
  { id: 'lesson', label: 'LESSON', jp: '教室' },
  { id: 'contact', label: 'CONTACT', jp: '問合せ' },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header className={`pf-nav ${scrolled ? 'pf-nav--scrolled' : ''}`}>
      <div className="pf-nav__inner">
        <a className="pf-nav__brand" href="#top" onClick={(e) => { e.preventDefault(); scrollTo('top'); }}>
          <img className="pf-nav__brand-logo" src={`${process.env.PUBLIC_URL}/logo.png`} alt="虹嶺庵" />
          <span className="pf-nav__brand-text">虹嶺庵 <span className="pf-nav__brand-en">KOUREIAN</span></span>
        </a>

        <nav className="pf-nav__links">
          {links.map((l) => (
            <button key={l.id} className="pf-nav__link" onClick={() => scrollTo(l.id)}>
              {l.label}
            </button>
          ))}
        </nav>

        <button className="pf-nav__burger" onClick={() => setOpen(!open)} aria-label="menu">
          <span /><span /><span />
        </button>
      </div>

      {open && (
        <div className="pf-nav__mobile">
          {links.map((l) => (
            <button key={l.id} className="pf-nav__mobile-link" onClick={() => scrollTo(l.id)}>
              <span className="pf-nav__mobile-en">{l.label}</span>
              <span className="pf-nav__mobile-jp">{l.jp}</span>
            </button>
          ))}
        </div>
      )}
    </header>
  );
}
